module.exports = __webpack_public_path__ + "static/sport/game-2.df23fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/game-2.png
// module id = 49O3
// module chunks = 0